<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputPreview'
export default {
  name: 'DAuthorPreview',
  extends: compoment
}
</script>
